<template>
  <section class="page-container">
    <!--
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    -->

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" label="编号"></el-table-column>
      <el-table-column prop="userId" label="用户"></el-table-column>
      <el-table-column prop="content" label="内容"></el-table-column>
      <el-table-column prop="imageList" label="图片">
        <template slot-scope="scope">
          <div v-if="scope.row.imageList && scope.row.imageList.length">
            <el-image
              v-for="(image, index) in scope.row.imageList"
              :key="index"
              :src="image.preview"
              :preview-src-list="imageSrcList(scope.row.imageList)"
              fit="cover"
              lazy
              style="width: 100px; height: 100px; margin-right: 10px"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <a @click="showReplies(scope.row.id)">查看回复</a>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <feedback-reply ref="feedbackReply" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import FeedbackReply from "./feedback-reply";
export default {
  components: { MyPagination, FeedbackReply },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    showReplies(feedbackId) {
      this.$refs.feedbackReply.show(feedbackId);
    },
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/feedback/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    imageSrcList(imageList) {
      if (!imageList || !imageList.length) {
        return [];
      }
      const ret = [];
      for (let i = 0; i < imageList.length; i++) {
        ret.push(imageList[i].preview);
      }
      return ret;
    },
  },
};
</script>

<style lang="scss" scoped></style>
